import store from '../store';

/**
 * Call API
 *
 * @param  {object} instance Vue instance.
 * @param  {string} method Axios request method.
 * @param  {string} route API route.
 * @param   {object} data API call data.
 * @returns {Promise} API call response.
 */
export default async (instance, method, route, data) => {
    instance.formProcessing = true;

    return instance.$http[method](route, data)
        .catch(error => {
            if (401 === error.response.status && store.state.user) {
                store.dispatch('handleExpiredLogin');
            }

            return error.response;
        })
        .finally(() => { instance.formProcessing = false });
};
